module.exports = __webpack_public_path__ + "img/home-orange.87b267a2.svg";